import { render, staticRenderFns } from "./AddList.vue?vue&type=template&id=de39380c&"
import script from "./AddList.vue?vue&type=script&lang=js&"
export * from "./AddList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports